import Component from '@glimmer/component';
import fade from 'ember-animated/transitions/fade';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { next } from '@ember/runloop';
import { task } from 'ember-concurrency';
import checkImage from '@dubbletrack/toolbox/utils/check-image';
import { inject as service } from '@ember/service';
export default class DeluxePlayerArtworkComponent extends Component {
  fade = fade;

  @tracked stationImageSource;
  @tracked showImageSource;
  @tracked airingImageSource;

  @service settings;

  loadBestImageSourceTask = task(async (feed) => {
    feed = feed || this.args.feed;

    if (feed?.airing?.image) {
      checkImage(feed.airing?.image?.medium_square?.url).then(
        () => this.airingImageSource = feed.airing.image,
      ).catch(e => { /* nope */ });
    } else {
      this.airingImageSource = undefined;
    }

    if (feed?.show?.image) {
      checkImage(feed.show?.image?.medium_square?.url).then(
        () => this.showImageSource = feed.show.image,
      ).catch(e => { /* nope */ });
    } else {
      this.showImageSource = undefined;
    }

    if (feed?.station?.image) {
      checkImage(feed.station?.image?.medium_square?.url).then(
        () => this.stationImageSource = feed.station.image,
      ).catch(e => { /* nope */ });
    } else {
      this.stationImageSource = undefined;
    }
  });

  @action
  colorSlurp() {
    // Vibrant.from(this.bestImageSource.medium_square.url)
    //   .getPalette()
    //   .then((palette) => {
    //     this.settings.colorOptions = palette;
    //   });
  }

  get bestImageSource() {
    return (
      this.airingImageSource ||
      this.showImageSource ||
      this.stationImageSource ||
      this.fallbackImageSource
    );
  }
}
